import React, { useEffect, useRef } from 'react';
import styles from './drdaniloblanco.module.scss';
import BackgroundLinks from './src/background-links.png';
import LinkWhatsapp from './src/1.png';

const WHATSAPP_NUMBER = '5512991797368';
const WHATSAPP_MSG = 'Olá! Vim pelo cartão digital e gostaria de mais informações...';

const whatsappLink = WHATSAPP_NUMBER
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`
    : '#';

const Drdaniloblanco: React.FC = () => {
    const trackRef = useRef<HTMLUListElement>(null);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const handleVisibility = () => {
            track.style.animationPlayState = document.hidden ? 'paused' : 'running';
        };

        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, []);

    return (
        <div className={styles.drdaniloblanco}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Dr. Danilo Blanco — cartão digital"
                    decoding="async"
                />
                <div className={styles.content}>
                    <a href={whatsappLink} className={styles.contentLink}>
                        <img
                            className={styles.contentImage}
                            src={LinkWhatsapp}
                            alt="WhatsApp — atendimentos e dúvidas"
                            decoding="async"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Drdaniloblanco;
